<section
  #accordion
  class="astral-accordion"
  [class.astral-accordion--expanded]="expanded"
  [class.astral-accordion--nested]="appearance === 'nested'"
  [style.width.px]="accordionWidth"
  [@.disabled]="prefersReducedMotion"
>
  <div class="astral-accordion__header-row">
    <button
      type="button"
      class="astral-accordion__header"
      [attr.id]="headerId"
      [attr.aria-label]="(translateHeader ? (header | translate) : header) + (displayCounter ? ', ' + displayCounter : '')"
      [attr.aria-controls]="panelId"
      [attr.aria-expanded]="expanded ? 'true' : 'false'"
      (click)="toggleAccordion()"
    ></button>

    <div class="astral-accordion__header-content">
      <span class="astral-accordion__header-main" aria-hidden="true">
        <span class="astral-accordion__header-slot">
          <ng-content select="[astralAccordionHeaderStart]"></ng-content>
        </span>

        <span class="astral-accordion__heading-row">
          <span class="astral-accordion__title">{{ translateHeader ? (header | translate) : header }}</span>
          @if (displayCounter) {
            <span
              class="astral-accordion__badge astral-accordion__badge--count"
              [class.astral-accordion__badge--compact]="counter > 9"
            >
              {{ displayCounter }}
            </span>
          }
          @if (indicator) {
            <span class="astral-accordion__badge astral-accordion__badge--indicator"></span>
          }
        </span>
      </span>

      @if (helpText) {
        <astral-popover class="astral-accordion__help" [helpText]="helpText"></astral-popover>
      }

      <span class="astral-accordion__header-spacer"></span>

      <span class="astral-accordion__header-meta" aria-hidden="true">
        <ng-content select="[astralAccordionHeaderEnd]"></ng-content>
        <i [class]="'astral-accordion__chevron ' + chevronIconClass"></i>
      </span>
    </div>
  </div>

  @if (expanded) {
    <div @panelVisibility [attr.id]="panelId" [attr.aria-labelledby]="headerId" class="astral-accordion__panel" role="region">
      <div class="astral-accordion__panel-inner">
        <ng-content></ng-content>
      </div>
    </div>
  }
</section>
